/* DMG Motion — theme interactions
   Vanilla JS. Uses Shopify AJAX Cart API (/cart/*.js). No dependencies. */
(function () {
  "use strict";

  const money = (cents) => {
    // Fallback formatter; Shopify money format injected via data attribute when available.
    const fmt = window.DMG && window.DMG.moneyFormat;
    const value = (cents / 100).toFixed(2);
    if (fmt) return fmt.replace(/\{\{\s*amount\s*\}\}/, value);
    return "$" + value;
  };

  /* ---------- Generic toggle for drawer/overlay elements ---------- */
  function setExpanded(el, open) {
    if (!el) return;
    el.setAttribute("aria-hidden", open ? "false" : "true");
  }

  document.addEventListener("DOMContentLoaded", function () {
    const body = document.body;
    const cartDrawer = document.getElementById("CartDrawer");
    const cartOverlay = document.getElementById("CartOverlay");
    const mobileMenu = document.getElementById("MobileMenu");

    function openCart() {
      setExpanded(cartDrawer, true);
      setExpanded(cartOverlay, true);
      body.style.overflow = "hidden";
    }
    function closeCart() {
      setExpanded(cartDrawer, false);
      setExpanded(cartOverlay, false);
      body.style.overflow = "";
    }
    function openMenu() { setExpanded(mobileMenu, true); body.style.overflow = "hidden"; }
    function closeMenu() { setExpanded(mobileMenu, false); body.style.overflow = ""; }

    // Bind triggers via data attributes
    document.querySelectorAll("[data-cart-open]").forEach((b) => b.addEventListener("click", (e) => { e.preventDefault(); openCart(); }));
    document.querySelectorAll("[data-cart-close]").forEach((b) => b.addEventListener("click", closeCart));
    document.querySelectorAll("[data-menu-open]").forEach((b) => b.addEventListener("click", openMenu));
    document.querySelectorAll("[data-menu-close]").forEach((b) => b.addEventListener("click", closeMenu));
    if (cartOverlay) cartOverlay.addEventListener("click", closeCart);

    document.addEventListener("keydown", (e) => {
      if (e.key === "Escape") { closeCart(); closeMenu(); }
    });

    /* ---------- Cart: fetch + render drawer ---------- */
    async function refreshCart(open) {
      try {
        const res = await fetch("/cart.js", { headers: { "Accept": "application/json" } });
        const cart = await res.json();
        renderCart(cart);
        updateCartCount(cart.item_count);
        if (open) openCart();
      } catch (err) { console.error("Cart refresh failed", err); }
    }

    function updateCartCount(count) {
      document.querySelectorAll("[data-cart-count]").forEach((el) => {
        el.textContent = count;
        el.classList.toggle("hidden", count === 0);
      });
    }

    function renderCart(cart) {
      const list = document.getElementById("CartItems");
      const subtotalEl = document.querySelector("[data-cart-subtotal]");
      const footEl = document.querySelector(".cart-drawer__foot");
      if (!list) return;

      if (cart.item_count === 0) {
        list.innerHTML = '<p class="empty-state">' + (window.DMG.strings.empty || "Your cart is empty.") + "</p>";
        if (footEl) footEl.classList.add("hidden");
        return;
      }
      if (footEl) footEl.classList.remove("hidden");

      list.innerHTML = cart.items.map((item) => {
        const img = item.image ? item.image.replace(/(\.[^.]+)(\?.*)?$/, "_160x$1") : "";
        const variant = item.options_with_values && item.options_with_values.length
          ? item.options_with_values.map((o) => o.value).join(" / ")
          : "";
        return (
          '<div class="cart-item" data-line-key="' + item.key + '">' +
            '<div class="cart-item__img">' + (img ? '<img src="' + img + '" alt="" loading="lazy">' : "") + "</div>" +
            "<div>" +
              '<a href="' + item.url + '" class="cart-item__title">' + item.product_title + "</a>" +
              (variant ? '<div class="cart-item__variant">' + variant + "</div>" : "") +
              '<div class="qty" data-line-qty style="margin-top:10px;">' +
                '<button type="button" data-qty-down aria-label="Decrease">&minus;</button>' +
                '<input type="text" value="' + item.quantity + '" data-qty-input readonly>' +
                '<button type="button" data-qty-up aria-label="Increase">+</button>' +
              "</div>" +
            "</div>" +
            "<div style=\"text-align:right;display:flex;flex-direction:column;gap:8px;\">" +
              '<div class="cart-item__title">' + money(item.final_line_price) + "</div>" +
              '<button type="button" class="cart-item__remove" data-line-remove>' + (window.DMG.strings.remove || "Remove") + "</button>" +
            "</div>" +
          "</div>"
        );
      }).join("");

      if (subtotalEl) subtotalEl.textContent = money(cart.total_price);
    }

    async function changeLine(key, quantity) {
      try {
        const res = await fetch("/cart/change.js", {
          method: "POST",
          headers: { "Content-Type": "application/json", "Accept": "application/json" },
          body: JSON.stringify({ id: key, quantity: quantity }),
        });
        const cart = await res.json();
        renderCart(cart);
        updateCartCount(cart.item_count);
      } catch (err) { console.error("Line change failed", err); }
    }

    // Delegated events inside cart drawer
    const drawerItems = document.getElementById("CartItems");
    if (drawerItems) {
      drawerItems.addEventListener("click", (e) => {
        const row = e.target.closest("[data-line-key]");
        if (!row) return;
        const key = row.getAttribute("data-line-key");
        const input = row.querySelector("[data-qty-input]");
        let qty = parseInt(input ? input.value : "1", 10) || 1;
        if (e.target.closest("[data-line-remove]")) { changeLine(key, 0); }
        else if (e.target.closest("[data-qty-up]")) { changeLine(key, qty + 1); }
        else if (e.target.closest("[data-qty-down]")) { changeLine(key, Math.max(0, qty - 1)); }
      });
    }

    /* ---------- Add to cart forms ---------- */
    document.querySelectorAll("form[action$='/cart/add'], form[data-product-form]").forEach((form) => {
      form.addEventListener("submit", async (e) => {
        e.preventDefault();
        const btn = form.querySelector("[type='submit']");
        const original = btn ? btn.textContent : "";
        if (btn) { btn.disabled = true; btn.textContent = "Adding…"; }
        try {
          const res = await fetch("/cart/add.js", {
            method: "POST",
            headers: { "Accept": "application/json" },
            body: new FormData(form),
          });
          if (!res.ok) { const err = await res.json(); throw new Error(err.description || "Add failed"); }
          await refreshCart(true);
          if (btn) btn.textContent = "Added ✓";
        } catch (err) {
          console.error(err);
          if (btn) btn.textContent = "Unavailable";
        } finally {
          setTimeout(() => { if (btn) { btn.disabled = false; btn.textContent = original; } }, 1200);
        }
      });
    });

    /* ---------- Standalone quantity steppers (product page) ---------- */
    document.querySelectorAll("[data-qty]").forEach((wrap) => {
      const input = wrap.querySelector("input");
      wrap.querySelector("[data-qty-up]") && wrap.querySelector("[data-qty-up]").addEventListener("click", () => { input.value = (parseInt(input.value, 10) || 1) + 1; });
      wrap.querySelector("[data-qty-down]") && wrap.querySelector("[data-qty-down]").addEventListener("click", () => { input.value = Math.max(1, (parseInt(input.value, 10) || 1) - 1); });
    });

    /* ---------- Product gallery thumbnails ---------- */
    const gallery = document.querySelector("[data-gallery]");
    if (gallery) {
      const mainImg = gallery.querySelector("[data-gallery-main] img");
      gallery.querySelectorAll("[data-gallery-thumb]").forEach((thumb) => {
        thumb.addEventListener("click", () => {
          const full = thumb.getAttribute("data-full");
          if (mainImg && full) mainImg.src = full;
          gallery.querySelectorAll("[data-gallery-thumb]").forEach((t) => t.setAttribute("aria-current", "false"));
          thumb.setAttribute("aria-current", "true");
        });
      });
    }

    /* ---------- Variant selection (product page) ---------- */
    const variantForm = document.querySelector("[data-product-form]");
    if (variantForm && window.DMG && window.DMG.variants) {
      const variants = window.DMG.variants;
      const idInput = variantForm.querySelector("[data-variant-id]");
      const priceEl = document.querySelector("[data-product-price]");
      const addBtn = variantForm.querySelector("[type='submit']");

      function currentOptions() {
        const selected = [];
        variantForm.querySelectorAll("[data-option-index]").forEach((group) => {
          const checked = group.querySelector("input:checked");
          if (checked) selected[parseInt(group.getAttribute("data-option-index"), 10)] = checked.value;
        });
        return selected;
      }
      function onChange() {
        const opts = currentOptions();
        const match = variants.find((v) => v.options.every((o, i) => o === opts[i]));
        if (!match) return;
        if (idInput) idInput.value = match.id;
        if (priceEl) priceEl.textContent = money(match.price);
        if (addBtn) {
          addBtn.disabled = !match.available;
          addBtn.textContent = match.available ? (window.DMG.strings.add || "Add to cart") : (window.DMG.strings.soldout || "Sold out");
        }
      }
      variantForm.querySelectorAll("[data-option-index] input").forEach((i) => i.addEventListener("change", onChange));
      onChange();
    }

    // Initial count sync
    refreshCart(false);
  });
})();
